import Skeleton from 'react-loading-skeleton'
import { range } from '../../utils/arrays'

export const ArtworkDetailsSkeleton = () => {
  return (
    <div className='flex flex-col space-y-3'>
      {range(0, 7).map(i => {
        return (
          <div key={i}>
            <Skeleton width='20%' height={16} borderRadius={8} />
            <Skeleton
              // width={`${width2}%`}
              width='70%'
              height={16}
              borderRadius={8}
            />
          </div>
        )
      })}
    </div>
  )
}
